import { createFileRoute } from '@tanstack/react-router';

import { BusinessAssociateCreateScreen } from '@/features/business-associates/components/platform/BusinessAssociateFormScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/business-associates/new')({
  beforeLoad: () => {
    requirePermission('ba:update');
  },
  component: BusinessAssociateCreateScreen,
  staticData: { crumb: 'New' },
});
